export const triton_connect = [
  {
    number: 'TC100',
    hasModel: false,
  },
  {
    number: 'TC101',
    hasModel: false,
  },
  {
    number: 'TC102',
    hasModel: false,
  },
  {
    number: 'TC103',
    hasModel: false,
  },
  {
    number: 'TC104',
    hasModel: false,
  },
  {
    number: 'TC105',
    hasModel: false,
  },
  {
    number: 'TC106',
    hasModel: false,
  },
  {
    number: 'TC107',
    hasModel: false,
  },
  {
    number: 'TC108',
    hasModel: false,
  },
  {
    number: 'TC109',
    hasModel: false,
  },
  {
    number: 'TC110',
    hasModel: false,
  },
  {
    number: 'TC111',
    hasModel: false,
  },
  {
    number: 'TC112',
    hasModel: true,
  },
  {
    number: 'TC113',
    hasModel: false,
  },
  {
    number: 'TC114',
    hasModel: false,
  },
  {
    number: 'TC115',
    hasModel: false,
  },
  {
    number: 'TC116',
    hasModel: false,
  },
  {
    number: 'TC117',
    hasModel: false,
  },
  {
    number: 'TC118',
    hasModel: false,
  },
  {
    number: 'TC119',
    hasModel: false,
  },
  {
    number: 'TC120',
    hasModel: false,
  },
  {
    number: 'TC121',
    hasModel: false,
  },
  {
    number: 'TC122',
    hasModel: false,
  },
  {
    number: 'TC123',
    hasModel: false,
  },
  {
    number: 'TC124',
    hasModel: false,
  },
  {
    number: 'TC125',
    hasModel: true,
  },
];
